import CallToAction from '@/components/elements/CallToAction';
import FaqCategory, {
  FaqCategoryType,
} from '@/components/elements/FaqCategory';
import SimpleCTA from '@/components/elements/SimpleCTA';
import SimpleHeader from '@/components/elements/SimpleHeader';
import Spacer from '@/components/elements/Spacer';
import StoreLinkAlt from '@/components/elements/StoreLink';
import ResourcesCarousel from '@/components/modules/ResourcesCarousel';
import { SimpleGrid } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { NextSeo } from 'next-seo';
import React from 'react';

export type FaqLayoutProps = {
  faqData: FaqCategoryType[];
};

const FaqLayout = ({ faqData }: FaqLayoutProps) => {
  const { t } = useTranslation(`faq`);
  return (
    <>
      <NextSeo
        title={t(`page_title`)}
        description={t(`page_title`)}
        openGraph={{
          title: t(`page_title`),
          description: t(`page_description`),
        }}
      />
      <SimpleHeader title={t(`header`)} lead={t(`lead`)} />
      <SimpleGrid
        className="boxed-container"
        columns={[1, null, null, 2]}
        gap={28}
      >
        {faqData.map((item) => (
          <FaqCategory
            key={item.id}
            id={item.id}
            questions={item.questions}
            title={item.title}
          />
        ))}
      </SimpleGrid>

      <Spacer height={100} />
      <SimpleCTA
        title={t(`call_to_action.title`)}
        description={t(`call_to_action.description`)}
      >
        <StoreLinkAlt
          href="https://apps.apple.com/tr/app/voltran-app/id1567581311"
          type="ios"
        />
        <StoreLinkAlt
          href="https://play.google.com/store/apps/details?id=com.voltran.app.voltran"
          type="android"
        />
      </SimpleCTA>
      <Spacer height={100} />
      <ResourcesCarousel />
      <Spacer height={100} />
      <CallToAction />
      <Spacer height={100} />
    </>
  );
};

export default FaqLayout;
